import { defineMessages } from 'react-intl-next';

const _default_1: {
	sortAscending: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sortDescending: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	sortAscending: {
		id: 'automation-table.sort.ascending.non-final',
		defaultMessage: 'Sort ascending',
		description: 'Label for ascending sort button',
	},
	sortDescending: {
		id: 'automation-table.sort.descending.non-final',
		defaultMessage: 'Sort descending',
		description: 'Label for descending sort button',
	},
});
export default _default_1;
